export default __webpack_public_path__ + "static/elevating-phone-a6c81df41e9eaff34a26896996a3e105.png";